import {Component, Input, OnInit} from '@angular/core';
import {Skill} from './skill.model';

@Component({
  selector: 'app-my-skill',
  templateUrl: './my-skill.component.html',
  styleUrls: ['./my-skill.component.css']
})
export class MySkillComponent implements OnInit {
  @Input() skill: Skill;

  constructor() {
  }

  ngOnInit() {
  }

}
